import {VeneList, VeneListActionbarType} from "../../../Atoms/VeneList";
import {DeleteSharp, PlayArrowSharp} from "@mui/icons-material";
import React from "react";

export type dataTestType = {
    name: string,
    id: number
}

export const TestPage = () => {
    const testData: dataTestType[] = [{
        name: "Test Page",
        id: 3
    }]

    const buttonConfig: VeneListActionbarType<dataTestType>[] = [
        {
            icon: <PlayArrowSharp/>,
            onClick: () => { console.log("clicked b1") }
        },
        {
            icon: <DeleteSharp/>,
            onClick: () => { console.log("clicked b2") }
        }
    ]

    return (
        <VeneList data={testData} buttonConfig={buttonConfig}/>
    )
}